const officeEnsembleSrc = new URL("../assets/blog/office-bg-2.jpg", import.meta.url).href;
const officeYoungestPilotSrc = new URL("../assets/blog/office-bg-1.jpg", import.meta.url).href;
const officeCoreCastSrc = new URL("../assets/blog/office-bg-3.jpg", import.meta.url).href;
const officePaperBackdropSrc = new URL("../assets/blog/office-bg-4.jpg", import.meta.url).href;
const parksLeslieSrc = new URL("../assets/blog/parks-bg-1.jpg", import.meta.url).href;
const parksEnsembleSrc = new URL("../assets/blog/parks-bg-2.jpg", import.meta.url).href;
const seinfeldPosterSrc = new URL("../assets/images/seinfeld-cast.jpg", import.meta.url).href;
const modernFamilyJaySrc = new URL("../assets/blog/modern-family-jay.jpg", import.meta.url).href;
const modernFamilyGloriaSrc = new URL("../assets/blog/modern-family-gloria.jpg", import.meta.url).href;
const modernFamilyPhilSrc = new URL("../assets/blog/modern-family-phil.jpg", import.meta.url).href;
const modernFamilyHaleySrc = new URL("../assets/blog/modern-family-haley.jpg", import.meta.url).href;
const modernFamilyMannySrc = new URL("../assets/blog/modern-family-manny.jpg", import.meta.url).href;
const brooklynNineNinePilotSrc = new URL("../assets/blog/brooklyn-nine-nine-pilot.jpg", import.meta.url).href;
const seinfeldPilotSrc = new URL("../assets/blog/seinfeld-pilot.jpg", import.meta.url).href;

const officePilotFiveSrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_0921.jpg";
const officeAndySrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_0814.jpg";
const officeKevinSrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_0346.jpg";
const officeKellySrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_1908.jpg";
const officeErinSrc = "https://img.nbc.com/files/scet/photos/22/5059/0042_NUP_137469_0034.jpg";
const officeRobertSrc = "https://www.nbc.com/sites/nbcblog/files/2023/06/the-office-james-spader2.jpg";
const officeNellieSrc = "https://www.nbc.com/sites/nbcblog/files/2023/07/the-office-nellie-bertram-1.jpg";
const officeAngelaDwightSrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_2583.jpg";
const officeOscarTobySrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_2039.jpg";
const officePhyllisTobySrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_2184.jpg";
const officeMeredithStanleySrc = "https://img.nbc.com/files/scet/photos/22/2820/NUP_133974_1524.jpg";
const parksLesliePromoSrc = "https://img.nbc.com/files/scet/photos/269/2873/NUP_134212_0120.jpg";
const parksAprilPromoSrc = "https://img.nbc.com/files/scet/photos/269/2873/NUP_134212_0678.jpg";
const parksCastPromoSrc = "https://img.nbc.com/files/scet/photos/269/2873/NUP_134212_1129.jpg";
const parksCastGroupSrc = "https://img.nbc.com/files/scet/photos/269/2873/NUP_134212_1214.jpg";
const seinfeldJerryGeorgeDinerSrc = "https://www.sonypictures.com/sites/default/files/2021-05/sei0702h.png";
const seinfeldJerryElaineSrc = "https://www.sonypictures.com/sites/default/files/2021-05/sei0412h_0.png";
const seinfeldCoreFourSubwaySrc = "https://www.sonypictures.com/sites/default/files/2021-05/seinf_3_img_26_h.png";
const seinfeldJerryGeorgePizzaSrc = "https://www.sonypictures.com/sites/default/files/2021-05/sei0909h.png";
const seinfeldJerryKramerApartmentSrc = "https://www.sonypictures.com/sites/default/files/2021-05/seinfeld_422-003.png";
const brooklynNineNineCastSrc = "https://static.tvmaze.com/uploads/images/original_untouched/402/1007484.jpg";
const brooklynNineNineAmyRosaTerrySrc =
  "https://commons.wikimedia.org/wiki/Special:Redirect/file/Brooklyn%20Nine-Nine%20Actors%20at%20the%202014%20NCLR%20Alma%20Awards.jpg";
const brooklynNineNineAndySrc =
  "https://commons.wikimedia.org/wiki/Special:Redirect/file/Andy-Samberg-David-Shankbone-2010-NYC-791x1024.jpg";
const brooklynNineNineJoeSrc =
  "https://commons.wikimedia.org/wiki/Special:Redirect/file/Joe%20Lo%20Truglio%202015.jpg";
const brooklynNineNineAndreSrc =
  "https://commons.wikimedia.org/wiki/Special:Redirect/file/Andre%20Braugher%202011%20%28cropped%29.jpg";
const modernFamilySeasonOnePosterSrc =
  "https://static.tvmaze.com/uploads/images/original_untouched/359/898320.jpg";
const sunnySeasonOneCastSrc =
  "https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p7896758_b_h9_ab.jpg";
const sunnySeasonOneGroupSrc =
  "https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p7896758_i_h9_aa.jpg";
const sunnyPilotCharlieSrc =
  "https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p3164399_e_h11_aa.jpg";
const sunnyDennisDeeSrc =
  "https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p3164404_e_v8_aa.jpg";
const sunnyFrankArrivalSrc =
  "https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p3164406_e_h10_af.jpg";
const sunnySeasonTwoKeyArtSrc =
  "https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p7896822_b_h9_ab.jpg";

export const blogMedia = {
  brooklynNineNinePilotCast: {
    src: brooklynNineNinePilotSrc,
    alt: "The original Brooklyn Nine-Nine cast around a precinct desk in 2013 publicity photography: Rosa, Holt, Boyle, Jake, Terry, Gina, and Amy.",
    sourceWidth: 1536,
    sourceHeight: 1078,
    sourceUrl: "https://www.heyuguys.com/flashes-eyes-dads-brooklyn-nine-nine-pilot-reviews/",
  },
  seinfeldPilotDiner: {
    src: seinfeldPilotSrc,
    alt: "George and Jerry seated in the pilot's diner while Claire pours coffee between them.",
    sourceWidth: 960,
    sourceHeight: 720,
    sourceUrl: "https://www.tvmaze.com/episodes/48067/seinfeld-1x01-good-news-bad-news",
  },
  officeEnsemble: {
    src: officeEnsembleSrc,
    alt: "The Office ensemble promo with the Scranton branch standing in the warehouse.",
  },
  officeYoungestPilot: {
    src: officeYoungestPilotSrc,
    alt: "The Office promo image featuring Kelly Kapoor, Ryan Howard, Jim Halpert, and the rest of the early ensemble in a park setting.",
  },
  officeCoreCast: {
    src: officeCoreCastSrc,
    alt: "The Office core cast promo with Ryan Howard, Jim Halpert, Michael Scott, Dwight Schrute, and Pam Beesly.",
  },
  officePaperBackdrop: {
    src: officePaperBackdropSrc,
    alt: "The Office cast promo featuring Ryan Howard, Jim Halpert, Michael Scott, Dwight Schrute, and Pam Beesly in front of a paper backdrop.",
  },
  officePilotFive: {
    src: officePilotFiveSrc,
    alt: "Pilot-era NBC cast photo featuring Ryan Howard, Jim Halpert, Michael Scott, Dwight Schrute, and Pam Beesly.",
  },
  officeAndy: {
    src: officeAndySrc,
    alt: "NBC cast photo featuring Andy Bernard from The Office.",
  },
  officeKevin: {
    src: officeKevinSrc,
    alt: "NBC cast photo featuring Kevin Malone from The Office.",
  },
  officeKelly: {
    src: officeKellySrc,
    alt: "NBC cast photo featuring Kelly Kapoor with Oscar Martinez from The Office.",
  },
  officeErin: {
    src: officeErinSrc,
    alt: "NBC photo featuring Ellie Kemper as Erin Hannon from The Office.",
  },
  officeRobert: {
    src: officeRobertSrc,
    alt: "James Spader as Robert California in The Office.",
  },
  officeNellie: {
    src: officeNellieSrc,
    alt: "Catherine Tate as Nellie Bertram in The Office.",
  },
  officeAngelaDwight: {
    src: officeAngelaDwightSrc,
    alt: "NBC cast photo featuring Angela Martin and Dwight Schrute from The Office.",
  },
  officeOscarToby: {
    src: officeOscarTobySrc,
    alt: "NBC cast photo featuring Oscar Martinez and Toby Flenderson from The Office.",
  },
  officePhyllisToby: {
    src: officePhyllisTobySrc,
    alt: "NBC cast photo featuring Phyllis Vance and Toby Flenderson from The Office.",
  },
  officeMeredithStanley: {
    src: officeMeredithStanleySrc,
    alt: "NBC cast photo featuring Meredith Palmer and Stanley Hudson from The Office.",
  },
  parksEnsemble: {
    src: parksEnsembleSrc,
    alt: "Parks and Recreation ensemble key art with Leslie Knope, Ron Swanson, April Ludgate, Andy Dwyer, Tom Haverford, Ann Perkins, Donna Meagle, and Jerry Gergich.",
  },
  parksLeslie: {
    src: parksLeslieSrc,
    alt: "Leslie Knope at a podium in front of the City of Pawnee seal.",
  },
  parksLesliePromo: {
    src: parksLesliePromoSrc,
    alt: "NBC season 1 promo image of Leslie Knope from Parks and Recreation.",
  },
  parksAprilPromo: {
    src: parksAprilPromoSrc,
    alt: "NBC season 1 promo image of Aubrey Plaza as April Ludgate from Parks and Recreation.",
  },
  parksCastPromo: {
    src: parksCastPromoSrc,
    alt: "NBC season 1 cast photo with Mark Brendanawicz, Tom Haverford, Leslie Knope, and Ann Perkins from Parks and Recreation.",
  },
  parksCastGroup: {
    src: parksCastGroupSrc,
    alt: "NBC season 1 Parks and Recreation ensemble photo featuring the early Pawnee team.",
  },
  seinfeldPoster: {
    src: seinfeldPosterSrc,
    alt: "Promotional poster for Seinfeld featuring Kramer, George, Elaine, and Jerry grouped together.",
  },
  seinfeldJerryGeorgeDiner: {
    src: seinfeldJerryGeorgeDinerSrc,
    alt: "Jerry Seinfeld and George Costanza sitting together in a diner booth in an official Seinfeld still.",
  },
  seinfeldJerryElaine: {
    src: seinfeldJerryElaineSrc,
    alt: "Jerry Seinfeld and Elaine Benes sitting close together on a couch in an official Seinfeld still.",
  },
  seinfeldCoreFourSubway: {
    src: seinfeldCoreFourSubwaySrc,
    alt: "George Costanza, Kramer, Jerry Seinfeld, and Elaine Benes standing together by a subway car in an official Seinfeld still.",
  },
  seinfeldJerryGeorgePizza: {
    src: seinfeldJerryGeorgePizzaSrc,
    alt: "Jerry Seinfeld and George Costanza standing side by side in a pizza shop in an official Seinfeld still.",
  },
  seinfeldJerryKramerApartment: {
    src: seinfeldJerryKramerApartmentSrc,
    alt: "Jerry Seinfeld in his apartment while Kramer talks animatedly on a large cordless phone in an official Seinfeld still.",
  },
  brooklynNineNineCast: {
    src: brooklynNineNineCastSrc,
    alt: "Brooklyn Nine-Nine ensemble promo featuring Jake Peralta, Amy Santiago, Captain Holt, Terry Jeffords, Rosa Diaz, Gina Linetti, and Charles Boyle.",
  },
  brooklynNineNineAmyRosaTerry: {
    src: brooklynNineNineAmyRosaTerrySrc,
    alt: "Stephanie Beatriz, Terry Crews, and Melissa Fumero speaking together onstage at the 2014 ALMA Awards.",
  },
  brooklynNineNineAndy: {
    src: brooklynNineNineAndySrc,
    alt: "Andy Samberg posing at a 2010 event in a close portrait photograph.",
  },
  brooklynNineNineJoe: {
    src: brooklynNineNineJoeSrc,
    alt: "Joe Lo Truglio in a close-up portrait at a 2015 sporting event.",
  },
  brooklynNineNineAndre: {
    src: brooklynNineNineAndreSrc,
    alt: "Andre Braugher in a close portrait at a 2011 media event.",
  },
  modernFamilySeasonOnePoster: {
    src: modernFamilySeasonOnePosterSrc,
    alt: "Season 1 Modern Family poster featuring Jay, Gloria, Manny, Claire, Phil, Haley, Alex, Luke, Mitchell, and Cameron.",
  },
  sunnySeasonOneCast: {
    src: sunnySeasonOneCastSrc,
    alt: "Season 1 promotional image of Mac, Dennis, Dee, and Charlie from It's Always Sunny in Philadelphia.",
  },
  sunnySeasonOneGroup: {
    src: sunnySeasonOneGroupSrc,
    alt: "Early promotional image of Mac, Dennis, Dee, and Charlie from It's Always Sunny in Philadelphia.",
  },
  sunnyPilotCharlie: {
    src: sunnyPilotCharlieSrc,
    alt: "Pilot episode still from It's Always Sunny in Philadelphia featuring Charlie Day as Charlie Kelly in Paddy's Pub.",
  },
  sunnyDennisDee: {
    src: sunnyDennisDeeSrc,
    alt: "Season 1 episode still from It's Always Sunny in Philadelphia featuring Glenn Howerton as Dennis Reynolds and Kaitlin Olson as Dee Reynolds in Paddy's Pub.",
  },
  sunnyFrankArrival: {
    src: sunnyFrankArrivalSrc,
    alt: "Season 2 episode still from It's Always Sunny in Philadelphia featuring Kaitlin Olson as Dee Reynolds and Danny DeVito as Frank Reynolds.",
  },
  sunnySeasonTwoKeyArt: {
    src: sunnySeasonTwoKeyArtSrc,
    alt: "Season 2 key art for It's Always Sunny in Philadelphia featuring Danny DeVito and the original core cast as floating illustrated heads.",
  },
  modernFamilyJay: {
    src: modernFamilyJaySrc,
    alt: "Official Modern Family cast portrait of Ed O'Neill as Jay Pritchett.",
    kind: "portrait",
    renderMode: "portrait",
    sourceWidth: 579,
    sourceUrl:
      "https://cdn1.edgedatg.com/aws/v2/abc/ModernFamily/person/737480/4bcde9c59d26ed77a2e09935f61099dd/579x579-Q90_4bcde9c59d26ed77a2e09935f61099dd.jpg",
  },
  modernFamilyGloria: {
    src: modernFamilyGloriaSrc,
    alt: "Official Modern Family cast portrait of Sofía Vergara as Gloria Pritchett.",
    kind: "portrait",
    renderMode: "portrait",
    sourceWidth: 579,
    sourceUrl:
      "https://cdn1.edgedatg.com/aws/v2/abc/ModernFamily/person/737258/f86f8c0abc1970276d2b1c33e419ef9a/579x579-Q90_f86f8c0abc1970276d2b1c33e419ef9a.jpg",
  },
  modernFamilyPhil: {
    src: modernFamilyPhilSrc,
    alt: "Official Modern Family cast portrait of Ty Burrell as Phil Dunphy.",
    kind: "portrait",
    renderMode: "portrait",
    sourceWidth: 579,
    sourceUrl:
      "https://cdn1.edgedatg.com/aws/v2/abc/ModernFamily/person/737386/c04cab82627c6910b31c54b1357b2d73/579x579-Q90_c04cab82627c6910b31c54b1357b2d73.jpg",
  },
  modernFamilyHaley: {
    src: modernFamilyHaleySrc,
    alt: "Official Modern Family cast portrait of Sarah Hyland as Haley Dunphy.",
    kind: "portrait",
    renderMode: "portrait",
    sourceWidth: 579,
    sourceUrl:
      "https://cdn1.edgedatg.com/aws/v2/abc/ModernFamily/person/737253/ad92b6717804d88e8fb9ccbd8a82607f/579x579-Q90_ad92b6717804d88e8fb9ccbd8a82607f.jpg",
  },
  modernFamilyManny: {
    src: modernFamilyMannySrc,
    alt: "Official Modern Family cast portrait of Rico Rodriguez as Manny Delgado.",
    kind: "portrait",
    renderMode: "portrait",
    sourceWidth: 579,
    sourceUrl:
      "https://cdn1.edgedatg.com/aws/v2/abc/ModernFamily/person/737246/47b1125000e4403bfb7f9643262286e5/579x579-Q90_47b1125000e4403bfb7f9643262286e5.jpg",
  },
};

export function getBlogMedia(mediaId) {
  return blogMedia[mediaId] ?? null;
}
